module.exports = __webpack_public_path__ + "img/電気回路_2_9_3.adf0fdf0.png";